// Dashboard.js
import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactEditList from "react-edit-list";
import { getDocs, collection, query, addDoc, orderBy, doc, deleteDoc, setDoc } from 'firebase/firestore/lite';
import {db} from './../firebase';
import { DASHBOARD_CRUD, notifyDashboardCrudError, failDashboardValidation, isBlank, handleDashboardCrud } from '../utils/dashboardCrud';
// import FileUploader from './../FileUploader';

// Using native HTML5 drag and drop
import { useDragAndDrop } from './useDragAndDrop';

const yearArray = [];
const today = new Date();
let firstPaperDate = new Date(2009, 1, 1);
while (firstPaperDate < today )
{
  const currentYear = firstPaperDate.getFullYear();
  yearArray.push({ value: currentYear, name: currentYear});
  firstPaperDate.setFullYear(currentYear+1);
}
// This is the schema
const schema = [
  { name: "id", type: "id" },
  { name: "title", type: "string" },
  { name: "url", type: "string" },
  { name: "year", type: yearArray.reverse() },
  { name: "enabled", type: [
      { value: true, name: "Si" },
      { value: false, name: "No" }
    ] 
  }
];

const headers = {
  "title"      : "Titulo",
  "url"        : "URL/Link",
  "year"       : "Año",
  "enabled"    : "Mostrar"
};

export const PatentsList = () => {

  const DOCUMENT_NAME = 'patents';

  const TITLE = 'Patentes';
  
  const [data, setData] = useState([]);
  const dataRef = useRef([]);

  const navigate = useNavigate();

  const goToDashboard = async () => {
    navigate('/dashboard');
  };

  // Keep dataRef in sync with data state
  useEffect(() => {
    dataRef.current = data;
  }, [data]);

  const ref = useRef(null);
  
  // Use drag and drop hook
  const { initDragAndDrop } = useDragAndDrop(data, setData, dataRef, DOCUMENT_NAME, TITLE, ref);

  const fetchData = async () => {
    try {
      const q = query(collection(db, DOCUMENT_NAME), orderBy('order'));
      const querySnapshot = await getDocs(q);
            const newData = querySnapshot.docs
                .map((doc) => ({ ...doc.data(), id:doc.id }));
            setData(newData);
      dataRef.current = newData;
      
      // Initialize drag and drop after data is loaded
      setTimeout(() => {
        initDragAndDrop();
      }, 1000);
    } catch (error) {
      notifyDashboardCrudError({ operation: DASHBOARD_CRUD.LOAD, entityName: TITLE, error });
      setData([]);
    }
    }

  // eslint-disable-next-line no-unused-vars
  const create = () => {
    [].forEach((item)=>{
      item.datos.forEach( async (paper)=>{
        let paperToInsert = {
          title : paper.tittle,
          url: paper.url,
          year: item.date,
          enabled: true
        };
        await handleDashboardCrud(DASHBOARD_CRUD.CREATE, TITLE, () =>
          addDoc(collection(db, DOCUMENT_NAME), paperToInsert)
        );
      });
    });
  }

  useEffect(()=>{
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="container-fluid mt-1">
        <div className="card shadow">
            <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                <button className="btn btn-danger" onClick={goToDashboard} >Regresar</button>
                <h3 className="mb-0">Listado de {TITLE}</h3>
                <button className="btn btn-danger" onClick={create} >Crear</button>
            </div>
            <div className="card-body">
                <div className="table-responsive">
                    <React.Fragment>
                      <div className="m-3 fw-bold">
                        Se pueden reordenar los {TITLE.toLowerCase()} moviendolas de orden en la lista
                      </div>
                      <ReactEditList
                        schema={schema}
                        headers={headers}
                        onLoad={() => data}
                        ref={ref}
                        format={{
                          url: function ProyectoRenderer(props) {
                            if ( props.value !== "" )
                            {
                              return <a href={props.value} target="_blank" rel="noreferrer">Link</a>;
                            }
                            else
                            {
                              return null;
                            }
                          }
                        }}
                        onUpdate={async (item) => {
                          // Call your API here
                          if (isBlank(item.title)) {
                            return failDashboardValidation({
                              operation: DASHBOARD_CRUD.UPDATE,
                              entityName: TITLE,
                              missingFields: ['Título'],
                              message: 'Debes capturar el título de la patente.',
                            });
                          }
                          item.enabled = item.enabled === 'false' || item.enabled === false ? false : true;
                          if ( !item.url )
                          {
                            item.url = '';
                          }
                          if ( !item.publishDate )
                          {
                            item.publishDate = new Date();
                          }
                          item.updatedDate = new Date();
                          try {
                            await setDoc(doc(db, DOCUMENT_NAME, item.id), item);
                          } catch (error) {
                            notifyDashboardCrudError({ operation: DASHBOARD_CRUD.UPDATE, entityName: TITLE, error });
                            return false;
                          }
                        }}
                        onDelete={async (item) => {
                          if (!window.confirm("Are you sure you want to delete it?")) return false;
                          try {
                            await deleteDoc(doc(db, DOCUMENT_NAME, item.id));
                          } catch (error) {
                            notifyDashboardCrudError({ operation: DASHBOARD_CRUD.DELETE, entityName: TITLE, error });
                            return false;
                          }
                        }}
                        onInsert={ async (item) => {
                          // Call your API here
                          if (isBlank(item.title)) {
                            return failDashboardValidation({
                              operation: DASHBOARD_CRUD.CREATE,
                              entityName: TITLE,
                              missingFields: ['Título'],
                              message: 'Debes capturar el título de la patente.',
                            });
                          }
                          if ( !item.url )
                          {
                            item.url = '';
                          }
                          if ( !item.year )
                          {
                            item.year = (new Date()).getFullYear().toString();
                          }
                          item.enabled = item.enabled === 'false' || item.enabled === false ? false : true;
                          item.updatedDate = new Date();
                          item.enabled = item.enabled === 'false' || item.enabled === false ? false : true;
                          item.order = data.length;
                          item.publishDate = new Date();
                          item.createdDate = new Date();
                          item.updatedDate = new Date();
                          try {
                            const docRef = await addDoc(collection(db, DOCUMENT_NAME), item);
                            item.id = docRef.id;
                          } catch (error) {
                            notifyDashboardCrudError({ operation: DASHBOARD_CRUD.CREATE, entityName: TITLE, error });
                            return false;
                          }
                        }}
                        className="table table-light table-fixed align-middle"
                        headClassName="table-primary"
                        inputClassName="w-100"
                        thClassName={{
                          // These allow to fix the column widths
                          title: "col-6",
                          url: "col-4",
                          year: "col-1",
                          buttons: "col-1",
                        }}
                        bodyClassName="sortable-items"
                        btnValidateClassName="btn btn-success p-0 m-0"
                        btnDeleteClassName="btn btn-danger py-0 px-1 m-0 mx-1"
                        btnCancelClassName="btn btn-secondary py-0 px-1 m-0 mx-1"
                        rowClassName="draggable"
                        insertClassName="not-draggable"
                        filler={<React.Fragment>&#8230;</React.Fragment>}
                      />
                    </React.Fragment>
                </div>
            </div>
        </div>
    </div>
  );
}
